module.exports = __webpack_public_path__ + "static/img/pages.2c6bb0b4.svg";